// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#copy-result-toast-modal .modal-dialog {
  width: 420px;
  max-width: 420px;
  z-index: 1060;
}
.copy-result-toast-modal.modal-content {
  border-radius: 8px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
